import { graphql, useLazyLoadQuery } from "react-relay";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import { Jun0Settings } from "./Jun0Settings";
import { Jun0SettingsPage } from "./Jun0SettingsPage";

import type { Jun0SettingsRootQuery } from "./__generated__/Jun0SettingsRootQuery.graphql";

export function Jun0SettingsRoot() {
  const data = useLazyLoadQuery<Jun0SettingsRootQuery>(
    graphql`
      query Jun0SettingsRootQuery {
        ...Jun0SettingsPage_query
        UrlConfig {
          jun0
        }
      }
    `,
    {},
  );

  // The Jun0 endpoint is written into the Relay store from /config/jun0.json at
  // bootstrap, and it is the same signal the sidebar uses to show the Jun0 nav
  // item, so the switch and the nav agree without a second source of truth.
  return (
    <Jun0SettingsPage queryRef={data}>
      <SettingsTabsLayout>
        <Jun0Settings isEnabled={!!data.UrlConfig?.jun0} />
      </SettingsTabsLayout>
    </Jun0SettingsPage>
  );
}
